// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping48: FC<Shipping48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M13.5 40c-1.667 0-3.033-.6-4.1-1.8-1.067-1.2-1.517-2.617-1.35-4.25h-5l.65-3h5.6a5.47 5.47 0 0 1 1.825-1.425c.717-.35 1.508-.525 2.375-.525s1.658.175 2.375.525A5.47 5.47 0 0 1 17.7 30.95h9.9L32.2 11H9.3l.15-.65c.167-.7.517-1.267 1.05-1.7A2.849 2.849 0 0 1 12.35 8h23.6L34 16.5h6.25l5.7 7.6L44 33.95h-4c.167 1.633-.292 3.05-1.375 4.25-1.083 1.2-2.458 1.8-4.125 1.8-1.667 0-3.033-.6-4.1-1.8-1.067-1.2-1.517-2.617-1.35-4.25H19c.167 1.633-.292 3.05-1.375 4.25-1.083 1.2-2.458 1.8-4.125 1.8Zm18.2-13.5h10.75l.3-1.65-4-5.35H33.3l-1.6 7Zm.05-13.65L32.2 11l-4.6 19.95.4-1.8 1.7-7.3 2.05-9ZM1.1 26.15l.75-3h11l-.75 3h-11Zm4-7.3.75-3h13l-.75 3h-13ZM13.5 37c.7 0 1.292-.25 1.775-.75.483-.5.725-1.083.725-1.75 0-.7-.242-1.292-.725-1.775C14.792 32.242 14.2 32 13.5 32c-.667 0-1.25.242-1.75.725S11 33.8 11 34.5c0 .667.25 1.25.75 1.75s1.083.75 1.75.75Zm21 0c.7 0 1.292-.25 1.775-.75.483-.5.725-1.083.725-1.75 0-.7-.242-1.292-.725-1.775C35.792 32.242 35.2 32 34.5 32c-.667 0-1.25.242-1.75.725S32 33.8 32 34.5c0 .667.25 1.25.75 1.75s1.083.75 1.75.75Z" />
        </svg>
    );
};

export default Shipping48;
